import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function IntegrationManagerRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.IntegrationManager', {
		url: '/admin/integrations',
		controllerAs: 'vm',
		controller: IntegrationManagerCtrl,
		templateUrl: '/ng/hub/Integration/Manager/IntegrationManagerCtrl.html?' + window.BUILD,
		resolve: {
			style: () => AssetManager.css('/ng/hub/Integration/Manager/IntegrationManagerCtrl.css'),
			// partners: AssetManager.endpoint('/v2/integration/partners'),
			partners: () => {
				return [
					// {
					// 	partner: 'forrester',
					// 	title: 'Connect Forrester',
					// 	tile_url: 'forrester.png',
					// },
					// {
					// 	partner: 'mintel',
					// 	title: 'Connect Mintel',
					// 	tile_url: 'mintel.png',
					// },
					// {
					// 	partner: 'euromonitor',
					// 	title: 'Connect Euromonitor',
					// 	tile_url: 'euromonitor.png',
					// },
					// {
					// 	partner: 'watch-me-think',
					// 	title: 'Connect Watch Me Think',
					// 	tile_url: 'watch-me-think.png',
					// },
				];
			},
			$title: () => 'Integrations',
		},
	});
}

export class IntegrationManagerCtrl {
	constructor(Identity, partners) {
		'ngInject';
		this.partners = partners;
		this.can = {
			box: Identity.can('manage_box'),
			slack: Identity.can('manage_slack'),
			email: Identity.can('submit'),
			curate: Identity.can('publish'),
			twitter: Identity.can('publish'),
			ifttt: Identity.can('publish'),
			firefox: Identity.can('submit'),
			chrome: Identity.can('submit'),
			servicenow: Identity.can('manage_servicenow'),
			embed: Identity.can('manage_embed'),
			salesforce: Identity.can('standard_intel'),
			iframe: Identity.can('standard_intel'),
			msteams: Identity.can('manage_msteams') && Identity.can('all'), // until after Teams-app approval
			syndicated: Identity.can('manage_syndicated_partners'),
		};
	}
}
